/*
  Lunveil — fiche produit.
  Au changement de variante (sans rechargement) :
  - met à jour le bloc « Disposition des notes » (9 / 10 / 12) ;
  - met à jour la ligne « Notes et accordage » du tableau de caractéristiques.
*/
(function () {
  'use strict';

  function selectedVariantTitle() {
    var checked = document.querySelector(
      'variant-picker input[type="radio"]:checked, .product-variant-picker input[type="radio"]:checked'
    );
    if (checked) {
      var label = document.querySelector('label[for="' + checked.id + '"]');
      return (label ? label.textContent : checked.value || '').trim();
    }
    var select = document.querySelector('variant-picker select, .product-variant-picker select');
    if (select) return select.options[select.selectedIndex].textContent.trim();
    return '';
  }

  function update() {
    var title = selectedVariantTitle();
    if (!title) return;

    var match = title.match(/^(\d+)/);
    var notes = match ? match[1] : null;

    if (notes) {
      document.querySelectorAll('[data-lunveil-disposition] [data-notes]').forEach(function (el) {
        el.hidden = el.dataset.notes !== notes;
      });
    }

    document.querySelectorAll('[data-lunveil-variant-label]').forEach(function (el) {
      el.textContent = title;
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-picker, .product-variant-picker, form[action*="/cart/add"]')) {
      window.setTimeout(update, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
